var map = {
	"./background.png": "a4e8",
	"./delete.png": "9a6d",
	"./delete.svg": "6d44",
	"./edit.png": "8fb1",
	"./live.gif": "9878",
	"./logo.png": "37de",
	"./multi.png": "7ce8",
	"./number.png": "7dea",
	"./pause.png": "d621",
	"./people.png": "0f3b",
	"./play.png": "c818",
	"./recycle.png": "ae18",
	"./reset.png": "23064",
	"./speed.png": "b6a4",
	"./tone.png": "865a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "744e";